import {
    ApplicationConfig,
    enableProdMode,
    importProvidersFrom,
    inject,
    makeEnvironmentProviders,
    provideAppInitializer,
    provideZoneChangeDetection,
} from '@angular/core';
import { bootstrapApplication, DomSanitizer } from '@angular/platform-browser';
import {
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';

import { AppModule } from './app/app.module';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { APP_CONFIG } from './app/app.config';
import { UilabMatIconRegistry } from '@uilab/ng-mat-components';

import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion<sup style="font-size:70%">&reg;</sup> license key

function provideIconSprite() {
    return makeEnvironmentProviders([]);
}

function provideUilabMatIconSets() {
    const spriteUrls = [
        '/assets/uilab/icons/sprites-styles/uilab-icon-sprite-filled-symbols.svg',
        '/assets/uilab/icons/sprites-styles/uilab-icon-sprite-outlined-symbols.svg',
        '/assets/uilab/icons/sprites-styles/uilab-icon-sprite-grayscale-symbols.svg',
    ];

    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            const uilabMatIconRegistry = inject(UilabMatIconRegistry);
            const sanitizer = inject(DomSanitizer);

            spriteUrls.forEach((spriteUrl) => {
                uilabMatIconRegistry.addSvgIconSet(
                    sanitizer.bypassSecurityTrustResourceUrl(spriteUrl),
                );
            });
        }),
    ]);
}

function buildAppConfig(config: unknown): ApplicationConfig {
    return {
        providers: [
            { provide: APP_CONFIG, useValue: config },
            provideZoneChangeDetection(),
            provideHttpClient(withInterceptorsFromDi()),
            importProvidersFrom(AppModule),
            provideIconSprite(),
            provideUilabMatIconSets(),
        ],
    };
}

fetch('/assets/config.json')
    .then((res) => res.json())
    .then((config) => {
        if (environment.production) {
            enableProdMode();
        }

        registerLicense(config.syncfusion.licenseKey);

        bootstrapApplication(AppComponent, buildAppConfig(config)).catch(
            (err) => console.error('Angular bootstrap error:', err),
        );
    });
